import { render, staticRenderFns } from "./ResearchStackedBarPlot2.vue?vue&type=template&id=0df472fe&scoped=true"
import script from "./ResearchStackedBarPlot2.vue?vue&type=script&lang=js"
export * from "./ResearchStackedBarPlot2.vue?vue&type=script&lang=js"
import style0 from "./ResearchStackedBarPlot2.vue?vue&type=style&index=0&id=0df472fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df472fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df472fe')) {
      api.createRecord('0df472fe', component.options)
    } else {
      api.reload('0df472fe', component.options)
    }
    module.hot.accept("./ResearchStackedBarPlot2.vue?vue&type=template&id=0df472fe&scoped=true", function () {
      api.rerender('0df472fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchStackedBarPlot2.vue"
export default component.exports